import React from "react";
import PropTypes from "prop-types";
import styles from "components/documents/multi-document-actions-container.scss";
import { dataType, documentPropType, mergeDocumentType } from "custom-prop-types";
import { DropdownModal } from "components/common/dropdown-modal";
import { Button } from "components/common/button";
import { MergeDocumentsModal } from "components/documents/modals/merge-documents-modal";
import { BatchDownloadForm } from "components/documents/modals/forms/batch-download-form";
import { SetViewedDisplay } from "components/documents/documents-grid/set-viewed-display";

export const MultiDocumentsActionsHamburger = ({
  columns,
  isBatchDownloadLoading,
  isBatchDownloadMode,
  isMergeDocumentsLoading,
  isMergeDocumentsMode,
  mergeDocument,
  onChangeViewedSetting,
  onDeselectMergeDocument,
  onEndBatchDownloadMode,
  onEndMergeDocumentsMode,
  onMergeDocuments,
  onSelectMergeDocument,
  onSelectMergeField,
  onStartBatchDownloadMode,
  onStartMergeDocumentsMode,
  onSubmitBatchDownloadDocuments,
  preferredCurrency,
  documents,
  selectedMergeDocumentId,
  selectedDocumentIds,
  userEmail
}) => {
  const findDocuments = (id) => documents.find(document => document.id === id);
  const selectedDocuments = selectedDocumentIds.map(findDocuments);
  return (
    <div className={ styles["hamburger-menu"] }>
      <Button link onClick={ onStartBatchDownloadMode }>Download as...</Button>
      <DropdownModal
        offsetLeft={ -50 }
        offsetTop={ 20 }
        onClose={ onEndBatchDownloadMode }
        visible={ isBatchDownloadMode }
        width={ 350 }
      >
        <BatchDownloadForm
          defaultEmail={ userEmail }
          isLoading={ isBatchDownloadLoading }
          onCancel={ onEndBatchDownloadMode }
          onSave={ onSubmitBatchDownloadDocuments }
        />
      </DropdownModal>

      <SetViewedDisplay
        documents={ documents }
        onChangeViewedSetting={ onChangeViewedSetting }
        selectedDocumentIds={ selectedDocumentIds }
      />

      { renderMergeDocumentsButton(onStartMergeDocumentsMode, documents, selectedDocumentIds, selectedDocuments) }
      <MergeDocumentsModal
        columns={ columns }
        documents={ documents }
        isMergeDocumentsLoading={ isMergeDocumentsLoading }
        isMergeDocumentsMode={ isMergeDocumentsMode }
        mergeDocument={ mergeDocument }
        onDeselectMergeDocument={ onDeselectMergeDocument }
        onEndMergeDocumentsMode={ onEndMergeDocumentsMode }
        onMergeDocuments={ onMergeDocuments }
        onSelectMergeDocument={ onSelectMergeDocument }
        onSelectMergeField={ onSelectMergeField }
        preferredCurrency={ preferredCurrency }
        selectedDocuments={ selectedDocuments }
        selectedMergeDocumentId={ selectedMergeDocumentId }
      />
    </div>
  );
};

MultiDocumentsActionsHamburger.defaultProps = {
  mergeDocument: null,
  selectedMergeDocumentId: "",
  selectedDocumentIds: []
};

MultiDocumentsActionsHamburger.propTypes = {
  columns: PropTypes.arrayOf(dataType).isRequired,
  documents: PropTypes.arrayOf(documentPropType).isRequired,
  isBatchDownloadLoading: PropTypes.bool.isRequired,
  isBatchDownloadMode: PropTypes.bool.isRequired,
  isMergeDocumentsLoading: PropTypes.bool.isRequired,
  isMergeDocumentsMode: PropTypes.bool.isRequired,
  mergeDocument: mergeDocumentType,
  onChangeViewedSetting: PropTypes.func.isRequired,
  onDeselectMergeDocument: PropTypes.func.isRequired,
  onEndBatchDownloadMode: PropTypes.func.isRequired,
  onEndMergeDocumentsMode: PropTypes.func.isRequired,
  onMergeDocuments: PropTypes.func.isRequired,
  onSelectMergeDocument: PropTypes.func.isRequired,
  onSelectMergeField: PropTypes.func.isRequired,
  onStartBatchDownloadMode: PropTypes.func.isRequired,
  onStartMergeDocumentsMode: PropTypes.func.isRequired,
  onSubmitBatchDownloadDocuments: PropTypes.func.isRequired,
  preferredCurrency: PropTypes.string.isRequired,
  selectedDocumentIds: PropTypes.arrayOf(PropTypes.string),
  selectedMergeDocumentId: PropTypes.string,
  userEmail: PropTypes.string.isRequired
};

const renderMergeDocumentsButton = (
  onStartMergeDocumentsMode,
  documents,
  selectedDocumentIds,
  selectedDocuments
) => {
  const isAllDocuments = selectedDocuments.some((document) => document.type !== "receipt");
  if (selectedDocumentIds.length === 1 || isAllDocuments) {
    return null;
  }
  return (
    <Button link onClick={ () => onStartMergeDocumentsMode(documents, selectedDocumentIds[0]) }>
      Merge documents
    </Button>
  );
};



// WEBPACK FOOTER //
// ./src/js/components/documents/documents-grid/multi-documents-actions-hamburger.jsx